module.exports = __webpack_public_path__ + "img/img-7.e128a92d.jpg";